<template>
  <!-- This example requires Tailwind CSS v2.0+ -->
  <div class="relative z-40 pointer-events-none" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity duration-200 pointer-events-none opacity-0" :class="show && 'pointer-events-auto !opacity-100'"></div>

    <div class="fixed z-10 inset-0 overflow-y-auto pointer-events-none">
      <div class="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['show'],
}

</script>
